import script from "./BarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=e446c35a&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e446c35a"]])

export default __exports__